/**
 * Génère un slug SEO-friendly à partir du nom et optionnellement de la référence d'un produit.
 * Format final : /product/scalextric-coffret-le-mans--abc123id
 * Le double tiret "--" sépare le slug de l'ID pour un parsing fiable.
 */
export function slugify(text) {
  return (text || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')                    // décompose les accents
    .replace(/[\u0300-\u036f]/g, '')    // supprime les diacritiques
    .replace(/[^a-z0-9\s-]/g, '')      // garde lettres, chiffres, espaces, tirets
    .trim()
    .replace(/\s+/g, '-')              // espaces → tirets
    .replace(/-+/g, '-');              // tirets multiples → un seul
}

/**
 * Construit le slug complet d'un produit : "nom-slugifié--id"
 */
export function productSlug(product) {
  const namePart = slugify(product.name);
  return `${namePart}--${product.id}`;
}

/**
 * Extrait l'ID depuis un slug produit "nom-slugifié--id"
 * Fonctionne aussi avec un ID brut (rétro-compatibilité).
 */
export function extractProductId(slugOrId) {
  const idx = slugOrId.lastIndexOf('--');
  if (idx === -1) return slugOrId; // ancien format ID brut
  return slugOrId.slice(idx + 2);
}